module.exports = __webpack_public_path__ + "media/packs/images/flags/TO-f3e444fb7f2d5f3cd7e5f76081139fae.png";